import type { PropsWithChildren } from 'react';
import React from 'react';
import Box from '@mui/material/Box';

import Header from 'src/components/other/Header';
import Footer from 'src/components/other/Footer';

import theme from 'src/utils/theme';
import { styledTag } from 'src/utils/styled';

const PageWrapper = styledTag('div')<{ $noPageScroll: boolean }>`
    background-color: ${theme.palette.background.paper};
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    ${(props) => (props.$noPageScroll ? 'max-height: 100vh' : '')}
`;

const FullWidthLayout: React.FC<PropsWithChildren & { noPageScroll?: boolean }> = ({
    children,
    noPageScroll = false,
}) => (
    <PageWrapper $noPageScroll={noPageScroll}>
        <Header />
        {children}
        <Box mt="auto">
            <Footer />
        </Box>
    </PageWrapper>
);

export default FullWidthLayout;
